import createPlotlyComponent from "react-plotly.js/factory";
import Plotly from "plotly.js-basic-dist-min";

const PlotComponent = createPlotlyComponent(Plotly);

export default PlotComponent;
